import { GET_NULL_WSPOSITIONS, GET_NULL_WSPOSITIONS_SUCCESS, GET_NULL_WSPOSITIONS_ERROR} from './actionTypes';

const initialState = {
    errorGetNullWsPositions: "",
    loadingGetNullWsPositions: false,
    ws_positions: null,
    successWs: ""
}

const getNullWsPositions = (state = initialState, action) => {
    switch (action.type) {
        case GET_NULL_WSPOSITIONS:
            state = {
                ...state,
                loadingGetNullWsPositions: true
            }
            break;
        case GET_NULL_WSPOSITIONS_SUCCESS:
            state = {
                ...state,
                loadingGetNullWsPositions: false,
                ws_positions: action.payload.ws_positions, 
                successWs: action.payload.message
            }
            break;
        case GET_NULL_WSPOSITIONS_ERROR:
            state = { ...state, errorGetNullWsPositions: action.payload, loadingGetNullWsPositions: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getNullWsPositions;